import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { ApplicationRoutes } from './app/routes';
import { AuthProvider } from './auth/auth-context';
import './auth/auth.css';
import { clientEnvironment } from './config/client-env';
import './styles/tokens.css';
import './ui/ui.css';

const rootElement = document.querySelector<HTMLDivElement>('#root');

if (!rootElement) {
  throw new Error('Le point de montage #root est introuvable.');
}

rootElement.dataset.environment = clientEnvironment.VITE_APP_ENV;

createRoot(rootElement).render(
  <StrictMode>
    <AuthProvider>
      <BrowserRouter>
        <ApplicationRoutes />
      </BrowserRouter>
    </AuthProvider>
  </StrictMode>,
);
